// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"364cd518","453":"53fd6229","732":"621192d6","977":"bee315ff"}[chunkId] + ".chunk.js";
};